"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAppletsOpenIdRequest = void 0;
var GetAppletsOpenIdRequest = /** @class */ (function () {
    function GetAppletsOpenIdRequest() {
    }
    return GetAppletsOpenIdRequest;
}());
exports.GetAppletsOpenIdRequest = GetAppletsOpenIdRequest;
;
//# sourceMappingURL=getAppletsOpenId.request.js.map